import {
  ICommonSearchActionType,
} from '../Common.actions';
import {createAction} from '@reduxjs/toolkit';
import {IInternshipHistoryRequest} from '../../types/requests/CompanyInternshipHistoryParamsModel';
import {
  CompanyInternshipSeasonDataModel,
} from '../../types/models/CompanyInternshipSeasonDataModel';
import {IInternDegreePoolsRequest} from '../../types/requests/CompanyInternDegreePoolsParamsModel';
import {CompanyInternDegreePoolsDataModel} from '../../types/models/CompanyInternDegreePoolsDataModel';
import {
  CompanyInternLocationsDataModel,
} from '../../types/models/CompanyInternLocationsDataModel';
import {CompanySummerRetentionDataModel} from '../../types/models/SummerRetentionDataModel';


export const INTERNSHIP_HISTORY: ICommonSearchActionType = {
  ERROR: 'internshipHistory/searchError',
  LOAD: 'internshipHistory/search',
  LOADED: 'internshipHistory/searchSuccess',
  REFRESH: 'internshipHistory/searchRefresh',
  CHANGE_VIEW: 'internshipHistory/searchChangeView',
};

export const INTERN_DEGREE_POOLS: ICommonSearchActionType = {
  ERROR: 'internDegreePools/searchError',
  LOAD: 'internDegreePools/search',
  LOADED: 'internDegreePools/searchSuccess',
  REFRESH: 'internDegreePools/searchRefresh',
  CHANGE_VIEW: 'internDegreePools/searchChangeView',
};

export const HISTORICAL_INTERNSHIP_LOCATIONS: ICommonSearchActionType = {
  ERROR: 'historicalInternshipLocations/searchError',
  LOAD: 'historicalInternshipLocations/search',
  LOADED: 'historicalInternshipLocations/searchSuccess',
  REFRESH: 'historicalInternshipLocations/searchRefresh',
  CHANGE_VIEW: 'historicalInternshipLocations/searchChangeView',
};

export const COMPANY_HISTORICAL_INTERN_DEGREES: ICommonSearchActionType = {
  ERROR: 'companyHistoricalInternDegrees/searchError',
  LOAD: 'companyHistoricalInternDegrees/search',
  LOADED: 'companyHistoricalInternDegrees/searchSuccess',
  REFRESH: 'companyHistoricalInternDegrees/searchRefresh',
  CHANGE_VIEW: 'companyHistoricalInternDegrees/searchChangeView',
};

export const MATCHED_STUDENTS: ICommonSearchActionType = {
  ERROR: 'matchedStudents/searchError',
  LOAD: 'matchedStudents/search',
  LOADED: 'matchedStudents/searchSuccess',
  REFRESH: 'matchedStudents/searchRefresh',
  CHANGE_VIEW: 'matchedStudents/searchChangeView',
};

export const UPCOMING_INTERN_LOCATIONS: ICommonSearchActionType = {
  ERROR: 'upcomingInternLocations/searchError',
  LOAD: 'upcomingInternLocations/search',
  LOADED: 'upcomingInternLocations/searchSuccess',
  REFRESH: 'upcomingInternLocations/searchRefresh',
  CHANGE_VIEW: 'upcomingInternLocations/searchChangeView',
};

export const UPCOMING_INTERN_DEGREES: ICommonSearchActionType = {
  ERROR: 'upcomingInternDegrees/searchError',
  LOAD: 'upcomingInternDegrees/search',
  LOADED: 'upcomingInternDegrees/searchSuccess',
  REFRESH: 'upcomingInternDegrees/searchRefresh',
  CHANGE_VIEW: 'upcomingInternDegrees/searchChangeView',
};

export const INTERNS_LIST: ICommonSearchActionType = {
  ERROR: 'internsList/searchError',
  LOAD: 'internsList/search',
  LOADED: 'internsList/searchSuccess',
  REFRESH: 'internsList/searchRefresh',
  CHANGE_VIEW: 'internsList/searchChangeView',
};

export const SEASON_INTERNS: ICommonSearchActionType = {
  ERROR: 'seasonInterns/searchError',
  LOAD: 'seasonInterns/search',
  LOADED: 'seasonInterns/searchSuccess',
  REFRESH: 'seasonInterns/searchRefresh',
  CHANGE_VIEW: 'seasonInterns/searchChangeView',
};

export const LOCATION_INTERNS: ICommonSearchActionType = {
  ERROR: 'locationInterns/searchError',
  LOAD: 'locationInterns/search',
  LOADED: 'locationInterns/searchSuccess',
  REFRESH: 'locationInterns/searchRefresh',
  CHANGE_VIEW: 'locationInterns/searchChangeView',
};

export const SUMMER_TO_SUMMER_RETENTION: ICommonSearchActionType = {
  ERROR: 'summerToSummerRetention/searchError',
  LOAD: 'summerToSummerRetention/search',
  LOADED: 'summerToSummerRetention/searchSuccess',
  REFRESH: 'summerToSummerRetention/searchRefresh',
  CHANGE_VIEW: 'summerToSummerRetention/searchChangeView',
};

export const ALL_SEASONS_INTERN_EXPERIENCE_TASK: ICommonSearchActionType = {
  ERROR: 'allSeasonsInternExperienceTask/searchError',
  LOAD: 'allSeasonsInternExperienceTask/search',
  LOADED: 'allSeasonsInternExperienceTask/searchSuccess',
  REFRESH: 'allSeasonsInternExperienceTask/searchRefresh',
  CHANGE_VIEW: 'allSeasonsInternExperienceTask/searchChangeView',
};

export const ALL_SEASONS_QUESTIONS: ICommonSearchActionType = {
  ERROR: 'allSeasonsQuestions/searchError',
  LOAD: 'allSeasonsQuestions/search',
  LOADED: 'allSeasonsQuestions/searchSuccess',
  REFRESH: 'allSeasonsQuestions/searchRefresh',
  CHANGE_VIEW: 'allSeasonsQuestions/searchChangeView',
};

export const LEARNING_CONTRACTS: ICommonSearchActionType = {
  ERROR: 'learningContracts/searchError',
  LOAD: 'learningContracts/search',
  LOADED: 'learningContracts/searchSuccess',
  REFRESH: 'learningContracts/searchRefresh',
  CHANGE_VIEW: 'learningContracts/searchChangeView',
};

export const INTERNSHIP_EXPERIENCE: ICommonSearchActionType = {
  ERROR: 'internshipExperience/searchError',
  LOAD: 'internshipExperience/search',
  LOADED: 'internshipExperience/searchSuccess',
  REFRESH: 'internshipExperience/searchRefresh',
  CHANGE_VIEW: 'internshipExperience/searchChangeView',
};

export const EVALUATION_MEETINGS: ICommonSearchActionType = {
  ERROR: 'evaluationMeetings/searchError',
  LOAD: 'evaluationMeetings/search',
  LOADED: 'evaluationMeetings/searchSuccess',
  REFRESH: 'evaluationMeetings/searchRefresh',
  CHANGE_VIEW: 'evaluationMeetings/searchChangeView',
};

export const internshipHistorySearch = createAction<IInternshipHistoryRequest>(INTERNSHIP_HISTORY.LOAD);
export const internshipHistorySearchRefresh = createAction<IInternshipHistoryRequest>(INTERNSHIP_HISTORY.REFRESH);
export const internshipHistorySearchSuccess = createAction<CompanyInternshipSeasonDataModel>(INTERNSHIP_HISTORY.LOADED);
export const internshipHistorySearchError = createAction<string>(INTERNSHIP_HISTORY.ERROR);

export const internDegreePoolsSearch = createAction<IInternDegreePoolsRequest>(INTERN_DEGREE_POOLS.LOAD);
export const internDegreePoolsSearchRefresh = createAction<IInternDegreePoolsRequest>(INTERN_DEGREE_POOLS.REFRESH);
export const internDegreePoolsSearchSuccess = createAction<CompanyInternDegreePoolsDataModel>(INTERN_DEGREE_POOLS.LOADED);
export const internDegreePoolsSearchError = createAction<string>(INTERN_DEGREE_POOLS.ERROR);

export const historicalInternshipLocationsSearch = createAction<string>(HISTORICAL_INTERNSHIP_LOCATIONS.LOAD);
export const historicalInternshipLocationsSearchRefresh = createAction<string>(HISTORICAL_INTERNSHIP_LOCATIONS.REFRESH);
export const historicalInternshipLocationsSearchSuccess = createAction<CompanyInternLocationsDataModel>(HISTORICAL_INTERNSHIP_LOCATIONS.LOADED);
export const historicalInternshipLocationsSearchError = createAction<string>(HISTORICAL_INTERNSHIP_LOCATIONS.ERROR);

export const companyHistoricalInternDegreesSearch = createAction<string>(COMPANY_HISTORICAL_INTERN_DEGREES.LOAD);
export const companyHistoricalInternDegreesSearchRefresh = createAction<string>(COMPANY_HISTORICAL_INTERN_DEGREES.REFRESH);
export const companyHistoricalInternDegreesSearchSuccess = createAction<CompanyInternDegreePoolsDataModel>(COMPANY_HISTORICAL_INTERN_DEGREES.LOADED);
export const companyHistoricalInternDegreesSearchError = createAction<string>(COMPANY_HISTORICAL_INTERN_DEGREES.ERROR);

export const matchedStudentsSearch = createAction<string>(MATCHED_STUDENTS.LOAD);
export const matchedStudentsSearchRefresh = createAction<string>(MATCHED_STUDENTS.REFRESH);
export const matchedStudentsSearchSuccess = createAction<CompanyInternshipSeasonDataModel>(MATCHED_STUDENTS.LOADED);
export const matchedStudentsSearchError = createAction<string>(MATCHED_STUDENTS.ERROR);

export const upcomingInternLocationsSearch = createAction<string>(UPCOMING_INTERN_LOCATIONS.LOAD);
export const upcomingInternLocationsSearchRefresh = createAction<string>(UPCOMING_INTERN_LOCATIONS.REFRESH);
export const upcomingInternLocationsSearchSuccess = createAction<CompanyInternLocationsDataModel>(UPCOMING_INTERN_LOCATIONS.LOADED);
export const upcomingInternLocationsSearchError = createAction<string>(UPCOMING_INTERN_LOCATIONS.ERROR);

export const upcomingInternDegreesSearch = createAction<string>(UPCOMING_INTERN_DEGREES.LOAD);
export const upcomingInternDegreesSearchRefresh = createAction<string>(UPCOMING_INTERN_DEGREES.REFRESH);
export const upcomingInternDegreesSearchSuccess = createAction<CompanyInternDegreePoolsDataModel>(UPCOMING_INTERN_DEGREES.LOADED);
export const upcomingInternDegreesSearchError = createAction<string>(UPCOMING_INTERN_DEGREES.ERROR);

export const internsListSearch = createAction<IInternshipHistoryRequest>(INTERNS_LIST.LOAD);
export const internsListSearchRefresh = createAction<IInternshipHistoryRequest>(INTERNS_LIST.REFRESH);
export const internsListSearchSuccess = createAction<CompanyInternshipSeasonDataModel>(INTERNS_LIST.LOADED);
export const internsListSearchError = createAction<string>(INTERNS_LIST.ERROR);

export const seasonInternsSearch = createAction<string>(SEASON_INTERNS.LOAD);
export const seasonInternsSearchRefresh = createAction<string>(SEASON_INTERNS.REFRESH);
export const seasonInternsSearchSuccess = createAction<CompanyInternshipSeasonDataModel>(SEASON_INTERNS.LOADED);
export const seasonInternsSearchError = createAction<string>(SEASON_INTERNS.ERROR);

export const locationInternsSearch = createAction<string>(LOCATION_INTERNS.LOAD);
export const locationInternsSearchRefresh = createAction<string>(LOCATION_INTERNS.REFRESH);
export const locationInternsSearchSuccess = createAction<CompanyInternLocationsDataModel>(LOCATION_INTERNS.LOADED);
export const locationInternsSearchError = createAction<string>(LOCATION_INTERNS.ERROR);

export const summerToSummerRetentionSearch = createAction<string>(SUMMER_TO_SUMMER_RETENTION.LOAD);
export const summerToSummerRetentionSearchRefresh = createAction<string>(SUMMER_TO_SUMMER_RETENTION.REFRESH);
export const summerToSummerRetentionSearchSuccess = createAction<CompanySummerRetentionDataModel>(SUMMER_TO_SUMMER_RETENTION.LOADED);
export const summerToSummerRetentionSearchError = createAction<string>(SUMMER_TO_SUMMER_RETENTION.ERROR);

export const allSeasonsInternExperienceTaskSearch = createAction<string>(ALL_SEASONS_INTERN_EXPERIENCE_TASK.LOAD);
export const allSeasonsInternExperienceTaskRefresh = createAction<string>(ALL_SEASONS_INTERN_EXPERIENCE_TASK.REFRESH);
export const allSeasonsInternExperienceTaskSearchSuccess = createAction<CompanyInternshipSeasonDataModel>(ALL_SEASONS_INTERN_EXPERIENCE_TASK.LOADED);
export const allSeasonsInternExperienceTaskSearchError = createAction<string>(ALL_SEASONS_INTERN_EXPERIENCE_TASK.ERROR);

export const allSeasonsQuestionsSearch = createAction<string>(ALL_SEASONS_QUESTIONS.LOAD);
export const allSeasonsQuestionsSearchRefresh = createAction<string>(ALL_SEASONS_QUESTIONS.REFRESH);
export const allSeasonsQuestionsSearchSuccess = createAction<CompanyInternshipSeasonDataModel>(ALL_SEASONS_QUESTIONS.LOADED);
export const allSeasonsQuestionsSearchError = createAction<string>(ALL_SEASONS_QUESTIONS.ERROR);

export const learningContractsSearch = createAction<string>(LEARNING_CONTRACTS.LOAD);
export const learningContractsSearchRefresh = createAction<string>(LEARNING_CONTRACTS.REFRESH);
export const learningContractsSearchSuccess = createAction<CompanyInternshipSeasonDataModel>(LEARNING_CONTRACTS.LOADED);
export const learningContractsSearchError = createAction<string>(LEARNING_CONTRACTS.ERROR);

export const internshipExperienceSearch = createAction<string>(INTERNSHIP_EXPERIENCE.LOAD);
export const internshipExperienceSearchRefresh = createAction<string>(INTERNSHIP_EXPERIENCE.REFRESH);
export const internshipExperienceSearchSuccess = createAction<CompanyInternshipSeasonDataModel>(INTERNSHIP_EXPERIENCE.LOADED);
export const internshipExperienceSearchError = createAction<string>(INTERNSHIP_EXPERIENCE.ERROR);

export const evaluationMeetingsSearch = createAction<string>(EVALUATION_MEETINGS.LOAD);
export const evaluationMeetingsSearchRefresh = createAction<string>(EVALUATION_MEETINGS.REFRESH);
export const evaluationMeetingsSearchSuccess = createAction<CompanyInternshipSeasonDataModel>(EVALUATION_MEETINGS.LOADED);
export const evaluationMeetingsSearchError = createAction<string>(EVALUATION_MEETINGS.ERROR);
